import { render } from "./GzCompile.vue?vue&type=template&id=34afcaf0"
import script from "./GzCompile.vue?vue&type=script&lang=js"
export * from "./GzCompile.vue?vue&type=script&lang=js"

import "./GzCompile.vue?vue&type=style&index=0&id=34afcaf0&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__